import React from 'react';

const AJAX_ASP = () => {
  return (
    <div >
      <h1>AJAX_ASP</h1>
      <p>Placeholder component for: "AJAX ASP"</p>
    </div>
  );
};

export default AJAX_ASP;
